import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';
import { DENIAL_REASONS_ACTION_TYPE } from 'store/system/actions';

const initialState = {
  HMDACodes: [],
  data: {},
};

const denialReasonsReducer = (state = initialState, { payload, type, meta }) => {
  switch (type) {
    case DENIAL_REASONS_ACTION_TYPE.GET_HMDA_CODES:
      return { ...state, HMDACodes: payload || initialState.HMDACodes };

    case DENIAL_REASONS_ACTION_TYPE.GET_DENIAL_REASONS:
      return { ...state, data: payload || initialState.data };

    case DENIAL_REASONS_ACTION_TYPE.CREATE_DENIAL_REASON:
    case DENIAL_REASONS_ACTION_TYPE.EDIT_DENIAL_REASON:
      return { ...state, data: { ...state.data, [payload.id]: payload } };

    case DENIAL_REASONS_ACTION_TYPE.DELETE_DENIAL_REASON:
      return { ...state, data: _.omit(state.data, meta.denialReasonId) };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default denialReasonsReducer;
